import { useLocation } from 'react-router-dom';
import { useTrainingSession, type Persona } from './session';

const PERSONA_LABELS: Record<Persona, string> = {
  anonymous: 'Anonymous visitor',
  free: 'Free learner',
  'pro-learner': 'Pro learner',
  manager: 'Manager (Pro)',
};

// Demo-only control, not a real account menu — deliberately labeled as
// such so it reads honestly as a presenter aid rather than a hidden
// product feature (design spec, "Simulated session state"). Rendered
// from App.tsx unconditionally (alongside the real Scam Checker and Risk
// Review pages), so it must gate itself on the route rather than relying
// on every call site to remember to — the design spec is explicit that
// this control is visible only under /training.
export function PersonaSwitcher() {
  const { persona, setPersona } = useTrainingSession();
  const { pathname } = useLocation();

  if (!pathname.startsWith('/training')) {
    return null;
  }

  return (
    <div className="tr-persona-switcher">
      <span className="tr-persona-switcher-label">Demo — viewing as:</span>
      <select
        className="tr-persona-switcher-select"
        value={persona}
        onChange={(e) => setPersona(e.target.value as Persona)}
        aria-label="Switch demo persona"
      >
        {(Object.keys(PERSONA_LABELS) as Persona[]).map((p) => (
          <option key={p} value={p}>
            {PERSONA_LABELS[p]}
          </option>
        ))}
      </select>
    </div>
  );
}
